export const isMenuLeft = ({ dimention, width }) =>
  // dimention === DIMENTIONS.LANDSCAPE ||
  width > 575;
